module.exports = __webpack_public_path__ + "img/ic-work_.12640390.svg";